<template>
  <h1 class="text-2xl font-bold mb-2">
    Ajouter un chat
  </h1>
  <FormulaireChat
    mode="ajout"
    :afficherFermerApresSucces="false"
    @sauvegarder="ajouterChat"
    @fermer="fermer"
  >
  </FormulaireChat>
</template>

<script setup>
import { ref } from "vue";
import FormulaireChat from "./FormulaireChat.vue";
import { useAdminAuth } from "../store/storeAdminAuth"; // <-- Import de useAdminAuth

const emit = defineEmits(["ajouterChat", "fermer"]);

const message = ref("");

const { fetchWithAuth } = useAdminAuth();

async function ajouterChat(chatEnvoyer, messageParam) {
  // chatEnvoyer contient les vraies valeurs du formulaire !
  try {
    const response = await fetchWithAuth(
      "https://api.animauxdelasecondechance.com/api/liste_chats/index.php",
      {
        method: "POST",
        body: JSON.stringify(chatEnvoyer),
      }
    );
    console.log("Réponse fetchWithAuth reçue :", response);

    if (!response.ok) {
      const errorText = await response.text();
      console.error("Erreur lors de l'ajout du chat:", errorText);
      throw new Error("Erreur lors de l'ajout du chat");
    }

    const messageSucces = messageParam || "Chat ajouté avec succès !";
    message.value = messageSucces;
    console.log("Chat ajouté avec succès :", messageSucces);

    emit("ajouterChat", chatEnvoyer, messageSucces);

    setTimeout(() => {
      emit("fermer");
      console.log("Modale fermée après ajout du chat");
    }, 2000); // Ferme la modale après 2 secondes

  } catch (error) {
    console.error("Erreur JS dans ajouterChat :", error);
    const messageErreur = "Erreur : " + error.message;
    message.value = messageErreur;
    // En cas d'erreur, émettre l'événement avec le message d'erreur
    emit("ajouterChat", chatEnvoyer, messageErreur);
  }
};

// Écouteur pour l'événement de fermeture
const fermer = () => {
  console.log("bouton fermer cliqué");
  // Émettre l'événement pour fermer la modale
  emit("fermer");
  console.log("Modale fermée");
  message.value = ""; // Réinitialiser le message à la fermeture
};
</script>

<style scoped></style>